import { FC, useState } from 'react';

// = Containers & Components =
import ButtonGroup from '@/common/components/ui/buttons/button-group/button-group';
import Button from '@/common/components/ui/buttons/button/button';
import { useHistory, useParams } from 'react-router-dom';
import { publishPoll } from '@/services/poll.service';
import { withAlert } from '@/helpers/notificationHelper';
import { mutate } from 'swr';

const MonitoringSettingsButtons: FC<{ canPublish: boolean }> = ({
  canPublish = false,
}) => {
  const { id } = useParams<{ id: string }>();
  const [shownModal, setShownModal] = useState(false);

  const history = useHistory();

  const closeModal = () => {
    setShownModal(false);
  };

  const openModal = () => {
    setShownModal(true);
  };

  return (
    <ButtonGroup type={'vertical'} gap={'extra-small'}>
      {canPublish ? (
        <Button
          onClick={() =>
            withAlert(() => {
              const res = publishPoll(Number(id));
              mutate(`monitoring-api/polls/${id}`);
              return res;
            })
          }
          size="large"
          type="submit"
          color="primary">
          Опубликовать
        </Button>
      ) : (
        <Button size="large" color="default">
          Мониторинг опубликован
        </Button>
      )}

      <Button size="large" color="secondary" onClick={openModal}>
        Удалить мониторинг
      </Button>
    </ButtonGroup>
  );
};

export default MonitoringSettingsButtons;
